



































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { getProductDetails } from "@/services";
import { ProductDetails } from "@/interfaces";

@Component
export default class DetailsDialog extends Vue {
  @Ref("details-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: Number, required: true })
  id!: number;

  loading = false;

  details: ProductDetails[] = [];

  async mounted() {
    this.loading = true;
    try {
      this.details = await getProductDetails(this.id);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  onSubmit() {
    this.$emit("ok", true);
    this.hide();
  }

  onCancelButton() {
    this.$emit("ok", false);
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
